import { render, staticRenderFns } from "./DeviceApp.vue?vue&type=template&id=65d38d28&scoped=true"
import script from "./DeviceApp.vue?vue&type=script&lang=js"
export * from "./DeviceApp.vue?vue&type=script&lang=js"
import style0 from "./DeviceApp.vue?vue&type=style&index=0&id=65d38d28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d38d28",
  null
  
)

export default component.exports